import React, { ReactNode, memo, useMemo, useState } from 'react';
import FormFieldToolTip, {
  FormFieldToolTipBlokProps,
} from '../FormFieldToolTip/FormFieldToolTip';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';
import classNames from 'classnames';

interface FormFieldProps {
  label: string;
  description?: string;
  errorMessage?: string;
  toolTip: FormFieldToolTipBlokProps[];
  toolTipLabel?: string;
  children: ReactNode;
}

const FormField: React.FC<FormFieldProps> = ({
  label,
  description,
  toolTip,
  toolTipLabel,
  children,
}) => {
  const hasTooltip = useMemo<boolean>(() => {
    if (toolTip.length) return true;
    return false;
  }, [toolTip]);
  const [toolTipComponent, setToolTipComponent] = useState<Boolean>(false);

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-start gap-x-3">
        <label className="font-dm-sans font-bold text-text/body">{label}</label>
      </div>
      {description && <p className="text-text/body">{description}</p>}
      {children}
      {hasTooltip && (
        <div>
          <a
            className="text-text/body-accent font-bold pt-2 pb-4 block underline cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              setToolTipComponent(!toolTipComponent);
            }}
          >
            {toolTipLabel}
          </a>
          {toolTip.map((tooltip: any) => (
            <div
              className={classNames(
                `fixed top-0 bottom-0 left-0 right-0 z-[60] opacity-100 transition-opacity duration-500 sm:hidden`,
                {
                  'translate-y-[100%] !opacity-0': !toolTipComponent,
                }
              )}
            >
              <div
                className={classNames(
                  'transition-all duration-700 h-full flex items-end bg-[#0B212ECC]'
                )}
                onClick={() => setToolTipComponent(false)}
              >
                <div
                  className={classNames(
                    'transition-all duration-500 translate-y-[0%]',
                    {
                      'translate-y-[80%]': !toolTipComponent,
                    }
                  )}
                >
                  <FormFieldToolTip
                    blok={tooltip}
                    toggle={setToolTipComponent}
                  />
                </div>
              </div>
            </div>
          ))}
          {toolTipComponent &&
            toolTip.map((tooltip: any) => (
              <div className="hidden sm:block">
                <FormFieldToolTip blok={tooltip} toggle={setToolTipComponent} />
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default memo(FormField);
